export default __webpack_public_path__ + "static/media/YoutubeIcon.5e9a6736.svg";